import {
    FETCH_PHONE_CARDS,
    FETCH_PHONE_CARDS_SUCCESS,
    FETCH_PHONE_CARDS_FAILED
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { get } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import store from "../store/store";

// Admin-portal helpers for the airtime voucher inventory. The pool node is
// admin-read / server-write only; imports go through the import_phone_cards
// Cloud Function so codes never pass through client SDK writes.

// Upload an airtime provider logo (admin portal). Returns the download URL
// the caller saves into settings.airtimeProviderIcons.<providerKey>.
export const uploadProviderIcon = async (providerKey, file) => {
    const { providerIconRef } = firebase;
    await uploadBytesResumable(providerIconRef(providerKey), file);
    return getDownloadURL(providerIconRef(providerKey));
};

// Tiny counters node — the ONLY automatic read on the inventory page.
// Returns { provider: { value: { available, used, lastImportAt?, lastRedeemAt? } } }
export const fetchPhoneCardsMeta = async () => {
    const { phoneCardsMetaRef } = firebase;
    const snapshot = await get(phoneCardsMetaRef);
    return snapshot.val() || {};
};

// One provider+denomination subtree, fetched on explicit demand (never at
// login). ~1000 records is an acceptable one-shot for an admin click.
export const fetchPhoneCards = (provider, value) => async (dispatch) => {
    const { phoneCardsPoolRef } = firebase;
    dispatch({
        type: FETCH_PHONE_CARDS,
        payload: null
    });
    try {
        const snapshot = await get(phoneCardsPoolRef(provider, value));
        const data = snapshot.val() || {};
        const arr = Object.keys(data).map(i => {
            data[i].id = i;
            data[i].provider = provider;
            data[i].value = value;
            return data[i];
        });
        arr.sort((a, b) => (b.importedAt || 0) - (a.importedAt || 0));
        dispatch({
            type: FETCH_PHONE_CARDS_SUCCESS,
            payload: arr
        });
    } catch (error) {
        dispatch({
            type: FETCH_PHONE_CARDS_FAILED,
            payload: error.message
        });
    }
};

// Bearer-authenticated call to the import_phone_cards Cloud Function.
// Plain promise — the view owns the transient import/dry-run state
// (same pattern as the Landmarks import UI).
export const importPhoneCards = async ({ provider, value, codes, dryRun }) => {
    const { auth, config } = firebase;
    const user = auth?.currentUser;
    if (!user) throw new Error('Not signed in');
    const idToken = await user.getIdToken(false);
    const settings = store.getState().settingsdata.settings;
    const host = (typeof window !== 'undefined' && window.location && settings?.CompanyWebsite === window.location.origin)
        ? window.location.origin
        : `https://${config.projectId}.web.app`;
    const res = await fetch(`${host}/import_phone_cards`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + idToken,
        },
        body: JSON.stringify({ provider, value, codes, dryRun: dryRun === true }),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw Object.assign(new Error(json.error || `Import failed (${res.status})`), json);
    }
    return json;
};
